
<form [formGroup]="profileForm" (ngSubmit)="nextClick()">

  <div class="wrapper">
    <div class="container flex-grow-1 overflow-auto">
      <div>
        <h5 class="inTitle mb-4 ">{{'visitreason.visitreason_heading'|translate}}</h5>
      </div>
      <div row>

        <div class="form-group mt-5">
          <label class="fw-bold mb-2">{{'visitreason.visitreason_label'|translate}}:<span class="text-danger">*</span></label>
          <textarea placeholder="{{'visitreason.visitreason_placeholder'|translate}}" class="form-control" id="visitreason"
                    (input)="CheckLength($any($event.target).value);" maxlength="300" rows="7"
                    tabindex="16" style="resize: none" formControlName="visitreason"
                    name="visitreason"></textarea>
          <span id="maxChar" class="pull-right" style="font-size: 10.0pt;">
            {{ wordCounter == 0 ? ('allergy.max' | translate) : (300 - wordCounter) + "/" }} 300

          </span><br>
                 <span *ngIf="!isvisitReasonEnter" class="err">
                   {{'visitreason.visitreason_error'|translate}}
                 </span>
          <!--<span *ngIf="profileForm.controls['visitreason'].touched && profileForm.controls['visitreason'].invalid">
            <span class="err"
                  *ngIf="profileForm.controls['visitreason'].errors && profileForm.controls['visitreason'].errors.required">
              {{'visitreason.visitreason_error'|translate}}
            </span>
          </span>-->
        </div>


        <!--<div class="form-group  col-md-12">
          <div class="border-bottom">
            <label class="fw-bold">Reason for Visit / Symptom:<span class="text-danger">*</span></label>
            <textarea name="visitreason" type="text" rows="3" formControlName="visitreason"
                      placeholder="Enter Visit Reason" class="form-control border-0"></textarea>
          </div>
          <span *ngIf="profileForm.controls['visitreason'].touched && profileForm.controls['visitreason'].invalid">
            <span class="err"
                  *ngIf="profileForm.controls['visitreason'].errors && profileForm.controls['visitreason'].errors.required">
              Visit reason required.
            </span>
          </span>

        </div>-->
      </div>
    </div>
  </div>
  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-outline-primary" type="button" (click)="backclick()">{{'button.back'|translate}}</button>
        <!--<p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
        <button class="btn btn-primary" type="button" (click)="nextClick()">{{'button.next'|translate}}</button>
      </div>
    </div>
  </footer>
</form>
